/**
 * Captures a snapshot thumbnail from the editor's preview canvas.
 * Used during auto-save to generate project card thumbnails.
 */

const THUMB_WIDTH = 320;
const THUMB_HEIGHT = 180;

/** Capture a data URL thumbnail from the first canvas in the preview panel */
export function capturePreviewThumbnail(): string | null {
  // Find the preview canvas (Three.js canvas in PreviewPanel)
  const canvas = document.querySelector<HTMLCanvasElement>('.preview-canvas');
  if (!canvas || canvas.width === 0 || canvas.height === 0) return null;

  try {
    // Create an offscreen canvas at thumbnail size
    const thumb = document.createElement('canvas');
    thumb.width = THUMB_WIDTH;
    thumb.height = THUMB_HEIGHT;
    const ctx = thumb.getContext('2d');
    if (!ctx) return null;

    // Draw scaled-down version
    ctx.drawImage(canvas, 0, 0, THUMB_WIDTH, THUMB_HEIGHT);
    return thumb.toDataURL('image/jpeg', 0.7);
  } catch {
    // Canvas may be tainted (cross-origin) — fail silently
    return null;
  }
}
